import React, { FC, useEffect, useState } from "react";
import ImgCrop from "antd-img-crop";
import { message, Upload, Spin } from "antd";
import { RcFile } from "antd/es/upload";
import styles from "./styles.module.less";
import { useTranslation } from "react-i18next";
import { IconFont } from "../IconFont";

export interface ImageComponentProps {
  edit?: boolean;
  size?: number | string;
  src?: string;
  style?: React.CSSProperties;
  className?: React.CSSProperties;

  value?: string;
  onChange?: (value: string) => void;

  uploadSuccess?: (imageURL: string) => void;
}

const ImageComponent: FC<ImageComponentProps> = ({
  edit = true,
  size = 72,
  src,
  style,
  value,
  onChange,
  uploadSuccess,
}) => {
  const { t } = useTranslation();

  const [uploading, setUploading] = useState(false);

  const imageStyles = () => {
    const styles = { width: size, height: size };
    Object.assign(styles, style);

    return styles;
  };

  const [imageUrl, setImageUrl] = useState(value);

  // src 优先度高
  useEffect(() => setImageUrl(src ? src : value), [src, value]);

  const beforeUpload = (file: RcFile) => {
    if (!/jpe?g|png$/.test(file.type)) {
      message.error(t("common.imgFormatError"));
      return false;
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error(t("common.imgLimit"));
      return false;
    }
    return true;
  };

  const imageChange = (info: any) => {
    const { status } = info.file;

    if (status === "uploading") {
      setUploading(true);
    } else {
      setUploading(false);
    }

    if (status === "done") {
      const { code, message: errmsg, data } = info.file.response;
      if (code !== 200) {
        return message.error(errmsg);
      }
      const { url } = data;
      setImageUrl(url);
      onChange && onChange(url);
      uploadSuccess && uploadSuccess(url);
    } else if (status === "error") {
      message.error(
        t("user.uploadFail", {
          name: info.file.name,
        })
      );
    }
  };

  return (
    <ImgCrop
      modalOk={t("common.confirm")}
      modalCancel={t("common.cancel")}
      modalTitle={t("common.editImg")}
      minZoom={0.2}
    >
      <Upload
        disabled={!edit}
        name="file"
        listType="picture"
        className="avatar-uploader"
        showUploadList={false}
        action="/api/v2/upload?folder=photos"
        beforeUpload={beforeUpload}
        onChange={imageChange}
        style={{ cursor: "pointer" }}
      >
        <Spin spinning={uploading} size="small">
          <div className={styles.groupLogo} style={imageStyles()}>
            {imageUrl ? (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundImage: `url('${imageUrl}')`,
                }}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#d9d9d9",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <i className="authing-icon authing-ad" />
              </div>
            )}
            {edit && (
              <div className={styles.mask}>
                <span>{t("common.modify")}</span>
              </div>
            )}
          </div>
          <div className={styles.maskIcon}>
            <IconFont type="authing-camera-line" />
          </div>
        </Spin>
      </Upload>
    </ImgCrop>
  );
};

export default ImageComponent;
